<template>
  <div class="min-h-screen px-6 py-8 md:px-10" @click="fecharMenuVariavel">
    <div class="w-full space-y-6">
      <div class="flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between">
        <div>
          <h1 class="mt-2 text-3xl text-gray-900">Importar Campanha</h1>
          <p class="mt-2 max-w-2xl text-sm text-gray-500">Configure e crie uma nova campanha.</p>
        </div>

        <div class="flex flex-col gap-3 sm:flex-row">
          <button type="button" :class="['icon-anim-trigger--back group', ui.actionButton]" @click="voltarParaCampanhas">
            <svg
              class="icon-anim icon-anim--back h-5 w-5 text-gray-500 transition"
              :style="{ color: $event?.target?.parentElement?.classList?.contains('group-hover') ? primaryColor : '#9ca3af' }"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              @mouseenter="$event.target.style.color = primaryColor"
              @mouseleave="$event.target.style.color = '#9ca3af'"
            >
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15.75 19.5L8.25 12l7.5-7.5" />
            </svg>
            Voltar
          </button>

          <button type="button" :class="ui.actionButton" @click="baixarModelo">
            <svg class="h-5 w-5 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 3v12m0 0l-3.5-3.5M12 15l3.5-3.5M4 21h16" />
            </svg>
            Download modelo
          </button>
        </div>
      </div>

      <form class="space-y-6" @submit.prevent="importarCampanha">
        <div class="overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-sm">
          <div class="border-b border-gray-100 px-6 py-5">
            <div class="flex flex-col gap-3 lg:flex-row lg:items-start lg:justify-between">
              <div>
                <h2 class="text-lg font-semibold text-gray-900">Informações Gerais</h2>
                <p class="mt-1 max-w-2xl text-sm text-gray-500">Preencha os dados principais da campanha antes do upload da base.</p>
              </div>

              <p class="max-w-md rounded-xl border border-gray-200 bg-white px-4 py-3 text-sm text-gray-500 shadow-sm">Uploads feitos até 10:30 são priorizados. Após as esse horário, a campanha pode adquirir um delay de até 3 horas. O retorno costuma acontecer entre 2h e 3h.</p>
            </div>
          </div>

          <div class="p-6">
            <div class="rounded-2xl border border-gray-100 bg-slate-50/60 p-4 md:p-5">
              <div class="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-12">
                <div class="flex flex-col gap-1 xl:col-span-5">
                  <label class="text-sm font-medium text-gray-500">Nome da campanha</label>
                  <input v-model="form.nome" type="text" placeholder="Ex: Campanha cobrança abril" :class="ui.inputField" />
                </div>

                <div class="flex flex-col gap-1 xl:col-span-3">
                  <label class="text-sm font-medium text-gray-500">Centro de custo</label>
                  <div class="relative group">
                    <select id="centrocusto" v-model="form.centrocusto" :class="ui.selectField">
                      <option value="">Selecione</option>
                      <option v-for="centro in centrosDeCusto" :key="centro.value" :value="centro.value">
                        {{ centro.label }}
                      </option>
                    </select>
                    <svg :class="ui.selectIcon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                    </svg>
                  </div>
                </div>

                <div class="flex flex-col gap-1 xl:col-span-4">
                  <label class="text-sm font-medium text-gray-500">Etiqueta / tabulação</label>
                  <div class="relative group">
                    <select id="etiqueta" v-model="form.etiqueta" :class="ui.selectField">
                      <option value="">Selecione as etiquetas</option>
                      <option v-for="etiqueta in etiquetas" :key="etiqueta.value" :value="etiqueta.value">
                        {{ etiqueta.label }}
                      </option>
                    </select>
                    <svg :class="ui.selectIcon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                    </svg>
                  </div>
                </div>

                <div class="flex flex-col gap-1 xl:col-span-3">
                  <label class="text-sm font-medium text-gray-500">Data do disparo</label>
                  <input v-model="form.dataDisparo" type="date" :class="ui.inputField" />
                </div>

                <div class="flex flex-col gap-1 xl:col-span-2">
                  <label class="text-sm font-medium text-gray-500">Hora</label>
                  <input v-model="form.horaDisparo" type="time" :class="ui.inputField" />
                </div>

                <div class="flex flex-col gap-1 xl:col-span-3">
                  <label class="text-sm font-medium text-gray-500">Mensagem</label>
                  <label class="flex h-11 cursor-pointer items-center gap-3 rounded-xl border border-gray-200 bg-white px-4 shadow-sm transition hover:border-gray-300">
                    <input v-model="form.editarMensagemManual" type="checkbox" class="h-4 w-4 rounded" />
                    <span class="text-sm font-medium text-gray-700">Editar mensagem manualmente</span>
                  </label>
                </div>

                <div class="flex flex-col gap-1 md:col-span-2 xl:col-span-3">
                  <label class="text-sm font-medium text-gray-500">Observação</label>
                  <textarea v-model="form.obs" rows="1" placeholder="Inclua instruções do envio ou observações." :class="ui.textareaField" />
                </div>
              </div>

              <div v-if="form.editarMensagemManual" class="mt-4 grid grid-cols-1 gap-4">
                <textarea
                  v-model="form.mensagemEditada"
                  rows="3"
                  @input="updateMensagemEditada"
                  placeholder="Digite a mensagem manualmente"
                  class="w-full rounded-2xl border border-gray-200 bg-white px-4 py-3 text-sm text-gray-700 shadow-sm outline-none transition focus:border-blue-100 focus:ring-2 focus:ring-blue-100"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="rounded-2xl border border-gray-200 bg-white p-6 shadow-sm">
          <div class="flex flex-col gap-3 border-b border-gray-100 pb-5 lg:flex-row lg:items-start lg:justify-between">
            <div>
              <h2 class="text-lg font-semibold text-gray-900">Arquivos da campanha</h2>
              <p class="mt-1 max-w-2xl text-sm text-gray-500">Faça o upload da base principal e, se necessário, anexe um arquivo complementar da campanha.</p>
            </div>
            <p class="max-w-md rounded-xl border border-gray-200 bg-white px-4 py-3 text-sm text-gray-500 shadow-sm">
              Recomendamos utilizar imagens no formato JPG para garantir melhor compatibilidade na formatação durante o envio.
            </p>
          </div>

          <div class="mt-6 grid grid-cols-1 gap-6 xl:grid-cols-2">
            <div class="rounded-2xl border border-gray-200 bg-slate-50 p-5">
              <div class="flex items-center justify-between gap-4">
                <div>
                  <h3 class="text-lg font-semibold text-gray-900">Arquivo principal</h3>
                  <p class="mt-1 text-sm text-gray-500">Base da campanha com os contatos e dados de disparo.</p>
                </div>

                <button type="button" :class="ui.secondaryButton" @click="abrirSeletorArquivoPrincipal">Selecionar</button>
              </div>

              <input ref="arquivoPrincipalInput" type="file" class="hidden" accept=".csv,.xlsx,.xls" @change="handleArquivoPrincipal" />

              <button
                type="button"
                :class="[ui.uploadDropzoneBase, isPrincipalDragging ? 'border-2' : 'border-gray-200 bg-white']"
                :style="{
                  borderColor: isPrincipalDragging ? primaryColor : '#e5e7eb',
                  backgroundColor: isPrincipalDragging ? getPrimaryBackground(0.1) : '#ffffff'
                }"
                @click="abrirSeletorArquivoPrincipal"
                @dragover.prevent="isPrincipalDragging = true"
                @dragleave.prevent="isPrincipalDragging = false"
                @drop.prevent="soltarArquivoPrincipal"
              >
                <svg class="h-8 w-8" :style="{ color: primaryColor }" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16.5V18a2 2 0 002 2h12a2 2 0 002-2v-1.5M8 12l4-4m0 0l4 4m-4-4v9" />
                </svg>
                <p class="mt-3 text-base font-medium text-gray-700">Suba a base da campanha</p>
                <p class="mt-2 max-w-sm text-sm text-gray-400">Clique para selecionar ou arraste o arquivo principal para esta área.</p>
              </button>

              <div :class="ui.uploadFileNameBox">
                {{ arquivoPrincipal ? arquivoPrincipal.name : "Nenhum arquivo principal selecionado." }}
              </div>
            </div>

            <div class="rounded-2xl border border-gray-200 bg-slate-50 p-5">
              <div class="flex items-center justify-between gap-4">
                <div>
                  <h3 class="text-lg font-semibold text-gray-900">Anexo da campanha</h3>
                  <p class="mt-1 text-sm text-gray-500">Imagem, PDF ou documento complementar enviado junto com a campanha.</p>
                </div>

                <button type="button" :class="ui.secondaryButton" @click="abrirSeletorAnexo">Selecionar</button>
              </div>

              <input ref="anexoInput" type="file" class="hidden" accept="image/*,.pdf,.doc,.docx" @change="handleAnexo" />

              <button
                type="button"
                :class="[ui.uploadDropzoneBase, isAnexoDragging ? 'border-green-400 bg-green-50' : 'border-gray-200 bg-white hover:border-green-300 hover:bg-green-50/30']"
                @click="abrirSeletorAnexo"
                @dragover.prevent="isAnexoDragging = true"
                @dragleave.prevent="isAnexoDragging = false"
                @drop.prevent="soltarAnexo"
              >
                <svg class="h-8 w-8 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21.44 11.05l-8.49 8.49a5.5 5.5 0 01-7.78-7.78l8.49-8.49a3.5 3.5 0 114.95 4.95L10.12 16.7a1.5 1.5 0 11-2.12-2.12l7.43-7.43" />
                </svg>
                <p class="mt-3 text-base font-medium text-gray-700">Anexe arquivo complementar</p>
                <p class="mt-2 max-w-sm text-sm text-gray-400">Use esta área para subir uma imagem, PDF ou documento adicional.</p>
              </button>

              <div :class="ui.uploadFileNameBox">
                {{ anexo ? anexo.name : "Nenhum anexo selecionado." }}
              </div>
            </div>
          </div>
        </div>

        <div v-if="previews && previews.length" class="rounded-2xl border border-gray-200 bg-white p-6 shadow-sm">
          <div class="mb-6 space-y-4">
            <div class="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
              <div>
                <h2 class="text-lg font-semibold text-gray-900">Prévia</h2>
                <label class="mt-3 flex w-max cursor-pointer items-center gap-3 text-sm font-medium text-gray-700" @click.stop>
                  <input v-model="editVariaveis" type="checkbox" class="h-4 w-4 rounded border-gray-300" :style="{ accentColor: primaryColor }" />
                  Editar Variáveis
                </label>
              </div>
            </div>

            <div v-if="editVariaveis" class="space-y-4">
              <div class="min-h-11 rounded-xl border border-gray-200 bg-gray-100 px-4 py-3 text-sm leading-7 text-gray-900 shadow-sm" @click.stop>
                <template v-if="mensagemEditavelPartes.length">
                  <template v-for="(part, index) in mensagemEditavelPartes">
                    <span v-if="part.type === 'text'" :key="`texto-${index}`" class="whitespace-pre-wrap">{{ part.value }}</span>
                    <span v-else :key="part.id" class="relative inline-block align-baseline">
                      <button
                        type="button"
                        class="mx-0.5 inline-flex min-h-7 items-center gap-2 rounded-md border px-2 py-0.5 text-sm font-semibold transition focus:outline-none"
                        :style="{
                          backgroundColor: getCampoMapeado(part.value) ? '#374151' : getPrimaryBackground(0.2),
                          borderColor: getCampoMapeado(part.value) ? '#374151' : primaryColor,
                          color: getCampoMapeado(part.value) ? 'white' : primaryColor
                        }"
                        :class="{ 'border-gray-800 bg-gray-800 text-white hover:bg-gray-800': getCampoMapeado(part.value) }"
                        @click.stop="toggleMenuVariavel(part.id)"
                      >
                        <span>{{ part.value }}</span>
                        <span v-if="getCampoMapeado(part.value)" class="rounded bg-white/20 px-1.5 py-0.5 text-xs font-medium">
                          {{ formatCampoLabel(getCampoMapeado(part.value)) }}
                        </span>
                      </button>

                      <div v-if="activeVariable === part.id" class="absolute left-0 top-full z-30 mt-2 w-64 overflow-hidden rounded-xl border border-gray-200 bg-white py-1 shadow-xl">
                        <button
                          v-for="k in keys"
                          :key="`${part.value}-${k}`"
                          type="button"
                          class="block w-full px-4 py-2 text-left text-sm font-medium transition"
                          :class="getCampoMapeado(part.value) === k ? 'bg-gray-800 text-white' : 'text-gray-700 hover:bg-gray-50'"
                          @click.stop="selecionarCampoParaVariavel(part.value, k)"
                        >
                          {{ formatCampoLabel(k) }}
                        </button>
                      </div>
                    </span>
                  </template>
                </template>
                <span v-else class="text-gray-400">Nenhuma mensagem para editar.</span>
              </div>

              <div v-if="updateKeys.length" class="grid grid-cols-1 gap-2 md:grid-cols-2">
                <div v-for="(item, idx) in updateKeys" :key="`${item.old_key}-${idx}`" class="flex items-center justify-between gap-3 rounded-xl border border-gray-200 bg-white px-4 py-3 text-sm text-gray-700">
                  <span class="min-w-0 truncate">
                    <strong>{{ item.old_key }}</strong>
                    <span class="mx-2 text-gray-400">→</span>
                    <strong>{{ formatCampoLabel(item.new_key) }}</strong>
                  </span>
                  <button type="button" aria-label="Remover mapeamento" class="text-lg leading-none text-red-600 hover:text-red-800" @click.stop="removerSubstituicao(item, idx)">×</button>
                </div>
              </div>
            </div>
          </div>

          <div class="grid grid-cols-1 gap-6 lg:grid-cols-2">
            <div>
              <h3 class="mb-3 text-sm font-semibold text-gray-700 uppercase text-gray-500">Contatos</h3>
              <div class="max-h-96 overflow-y-auto rounded-xl border border-gray-200 bg-gray-50 p-3">
                <div v-if="previews.length" class="space-y-2">
                  <div v-for="(p, idx) in previews.slice(0, previewLimit)" :key="idx" class="rounded bg-white p-2 text-xs text-gray-700">
                    <span class="font-medium" :style="{ color: primaryColor }">{{ idx + 1 }}.</span>
                    {{ formatPreviewContact(p.contato) }}
                  </div>
                </div>
              </div>
            </div>

            <div>
              <h3 class="mb-3 text-sm font-semibold text-gray-700 uppercase text-gray-500">Mensagens</h3>
              <div class="max-h-96 overflow-y-auto rounded-xl border border-gray-200 bg-gray-50 p-3">
                <div v-if="previews.length" class="space-y-2">
                  <div v-for="(p, idx) in previews.slice(0, previewLimit)" :key="idx" class="rounded bg-white p-2 text-xs text-gray-700 leading-relaxed">
                    <span class="font-medium" :style="{ color: primaryColor }">{{ idx + 1 }}.</span>
                    <span v-html="getHtmlFrom(p.mensagem)" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Preview da base importada -->
        <div v-if="previews && previews.length" class="rounded-2xl border border-gray-200 bg-white p-6 shadow-sm">
          <div class="flex items-center justify-between mb-4">
            <h2 class="text-lg font-semibold text-gray-900">Pré-visualização da base</h2>
            <div class="text-sm text-gray-500">Total: {{ totalDeContatos || previews.length }}</div>
          </div>

          <div class="overflow-x-auto">
            <table class="w-full min-w-max text-left text-sm text-gray-600">
              <thead>
                <tr class="border-b border-gray-300 text-gray-500">
                  <th class="pb-2 font-medium">#</th>
                  <th v-for="k in keys" :key="k" class="pb-2 font-medium">{{ k }}</th>
                  <th class="pb-2 font-medium">Mensagem</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(p, idx) in previews.slice(0, previewLimit)" :key="idx" class="border-b border-gray-200">
                  <td class="py-2 text-gray-500">{{ idx + 1 }}</td>
                  <td v-for="k in keys" :key="k" class="py-2 text-gray-700">{{ formatCell(p.contato ? p.contato[k] : "") }}</td>
                  <td class="py-2 text-gray-700">{{ formatCell(p.mensagem) }}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="mt-3 flex items-center justify-between">
            <div class="text-sm text-gray-500">Mostrando {{ Math.min(previews.length, previewLimit) }} de {{ previews.length }}</div>
            <div class="flex items-center gap-2">
              <button v-if="previewLimit < previews.length" type="button" :class="ui.secondaryButton" @click="previewLimit = Math.min(previewLimit + 5, previews.length)">Mostrar mais</button>
              <button v-else type="button" :class="ui.secondaryButton" @click="previewLimit = 5">Reduzir</button>
              <button type="button" :class="ui.secondaryButton" @click="removeFileCampaign">Remover arquivo</button>
            </div>
          </div>
        </div>

        <div v-if="feedback.message" class="rounded-2xl border px-4 py-3 text-sm" :class="feedback.type === 'success' ? 'border-green-200 bg-green-50 text-green-700' : 'border-amber-200 bg-amber-50 text-amber-700'">
          {{ feedback.message }}
        </div>

        <div class="flex flex-col gap-3 sm:flex-row sm:justify-end">
          <button
            type="submit"
            class="h-11 rounded-xl px-6 font-medium text-white transition"
            :style="{ backgroundColor: primaryColor }"
            @mouseenter="$event.target.style.backgroundColor = mixPrimaryColor('#111827', 0.2)"
            @mouseleave="$event.target.style.backgroundColor = primaryColor"
          >
            Salvar campanha
          </button>
        </div>
      </form>

      <div v-if="isLoading" class="fixed left-0 top-80 z-50 w-full text-center text-lg font-bold text-zinc-600">
        <span class="text-green-600">{{ progresso }}</span> / 100%
      </div>
      <div v-if="isLoadingRedirect" class="fixed left-0 top-80 z-50 w-full text-center text-lg font-bold text-zinc-600">
        <p>Aguarde, você será redirecionado em alguns segundos...</p>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import { colorMixin } from "@/utils/colorMixin";
import { formatarMensagem } from "@/utils/formatarMensagem";

export default {
  mixins: [colorMixin],
  components: {},
  data() {
    return {
      showTooltip: false,
      isLoading: false,
      isLoadingRedirect: false,
      progresso: 0,
      route: "campaign",
      partitionCampaign: false,
      moment: moment,
      previews: [],
      keys: [],
      previewLimit: 5,
      editVariaveis: false,
      old_key: "",
      activeVariable: null,
      updateKeys: [],
      showContextMenu: false,
      centroscusto: [],
      zaps: [],
      tags: [],
      arquivoPrincipal: null,
      anexo: null,
      isPrincipalDragging: false,
      isAnexoDragging: false,
      feedback: {
        type: "warning",
        message: ""
      },
      ui: {
        actionButton:
          "flex h-11 items-center justify-center gap-2 rounded-xl border border-gray-200 bg-white px-5 font-medium text-gray-700 shadow-sm transition-all duration-200 hover:-translate-y-0.5 hover:border-gray-300 hover:bg-gray-50 hover:shadow-md",
        secondaryButton: "rounded-xl border border-gray-200 bg-white px-4 py-2 text-sm font-medium text-gray-700 transition hover:bg-gray-50",
        inputField: "h-11 w-full rounded-xl border border-gray-200 bg-white px-4 text-gray-700 shadow-sm outline-none transition-all duration-200",
        selectField: "h-11 w-full cursor-pointer appearance-none rounded-xl border border-gray-200 bg-white bg-none px-4 pr-10 text-gray-700 shadow-sm outline-none transition-all duration-200",
        selectIcon: "select-icon pointer-events-none absolute right-3 top-1/2 h-5 w-5 -translate-y-1/2 text-gray-400 transition-all duration-200",
        textareaField: "h-11 w-full resize-none rounded-xl border border-gray-200 bg-white px-4 py-3 text-gray-700 shadow-sm outline-none transition-all duration-200",
        uploadDropzoneBase: "mt-5 flex min-h-48 w-full flex-col items-center justify-center rounded-[28px] border-2 border-dashed px-6 text-center transition",
        uploadFileNameBox: "mt-4 rounded-xl border border-gray-200 bg-white px-4 py-3 text-sm text-gray-600"
      },
      shootingDate: moment().toISOString(),
      shootingTime: moment().add(40, "m").format("HH:mm"),
      exemploOutput: ``,
      form: {
        nome: "",
        dataDisparo: "",
        horaDisparo: "",
        file: "",
        dataHoraDisparo: "",
        metodo: "",
        obs: "",
        etiqueta: "",
        tags: [],
        centrocusto: null,
        salvarOperador: false,
        arquivo: null,
        editarMensagemManual: false,
        mensagemEditada: ""
      },
      analiseMensagem: {
        color: "",
        status: "",
        palavrasChaves: [],
        media: 0,
        suggestions: null,
        observation: null,
        recommendation: null
      },
      totalDeContatos: 0,
      dropzoneBody: {
        maxFiles: 1,
        addRemoveLinks: true,
        capture: true,
        dictDefaultMessage: "Clique ou arraste seu anexo aqui",
        dictRemoveFile: "Remover"
      },
      dropzoneCampaignOptions: this.$http.getDropzoneConfig(`campanhasLZV2/preview-campanha-import`, "post", {
        maxFiles: 1,
        addRemoveLinks: true,
        capture: true,
        dictDefaultMessage: `Clique ou arraste o arquivo da campanha aqui`,
        dictRemoveFile: "Remover"
      })
    };
  },
  mounted() {
    this.sockets.subscribe(`progressao_${this.$store.state.user._id}`, (progresso) => {
      this.progresso = progresso;
    });
  },
  beforeDestroy() {
    this.sockets.unsubscribe(`progressao_${this.$store.state.user._id}`);
  },
  computed: {
    centrosDeCusto() {
      return (this.centroscusto || [])
        .map((centro) => ({
          value: centro._id || centro.id || centro.value || "",
          label: centro.nome || centro.label || "Sem nome"
        }))
        .filter((centro) => centro.value);
    },
    etiquetas() {
      return (this.tags || [])
        .map((tag) => ({
          value: tag._id || tag.id || tag.value || "",
          label: tag.nome || tag.label || "Sem nome"
        }))
        .filter((tag) => tag.value);
    },
    mensagemBaseEdicao() {
      const primeiroPreview = this.previews && this.previews[0];
      if (primeiroPreview && primeiroPreview._mensagemOriginalImport !== undefined) {
        return primeiroPreview._mensagemOriginalImport || "";
      }

      if (this.form.mensagemEditada) {
        return this.form.mensagemEditada;
      }

      return primeiroPreview && primeiroPreview.mensagem ? primeiroPreview.mensagem : "";
    },
    mensagemEditavelPartes() {
      return this.montarPartesMensagem(this.mensagemBaseEdicao);
    },
    variaveisMensagem() {
      return this.extrairVariaveisMensagem(this.mensagemBaseEdicao);
    }
  },
  methods: {
    applyDynamicFocusStyles(event) {
      event.target.style.borderColor = this.primaryColor;
      event.target.style.boxShadow = `0 0 0 2px ${this.getPrimaryBackground(0.5)}`;
    },
    removeDynamicFocusStyles(event) {
      event.target.style.borderColor = "#d1d5db";
      event.target.style.boxShadow = "none";
    },
    applySelectIconColor(element) {
      const svg = element.querySelector("svg");
      if (svg) {
        svg.style.color = this.primaryColor;
      }
    },
    removeSelectIconColor(element) {
      const svg = element.querySelector("svg");
      if (svg) {
        svg.style.color = "#9ca3af";
      }
    },
    getRegexVariaveis() {
      return /(\{#[^}]+#\}|#[^#\n\r]+#|\{\{\d+\}\})/g;
    },
    extrairVariaveisMensagem(mensagem) {
      const texto = mensagem === null || mensagem === undefined ? "" : String(mensagem);
      const regex = this.getRegexVariaveis();
      const variaveis = [];
      const vistas = {};
      let match;

      while ((match = regex.exec(texto)) !== null) {
        const variavel = match[0];
        if (!vistas[variavel]) {
          vistas[variavel] = true;
          variaveis.push(variavel);
        }
      }

      return variaveis;
    },
    montarPartesMensagem(mensagem) {
      const texto = mensagem === null || mensagem === undefined ? "" : String(mensagem);
      if (!texto) return [];

      const regex = this.getRegexVariaveis();
      const partes = [];
      let ultimoIndex = 0;
      let match;

      while ((match = regex.exec(texto)) !== null) {
        if (match.index > ultimoIndex) {
          partes.push({
            type: "text",
            value: texto.slice(ultimoIndex, match.index)
          });
        }

        partes.push({
          type: "variable",
          id: `variavel-${match.index}-${match[0]}`,
          value: match[0]
        });

        ultimoIndex = regex.lastIndex;
      }

      if (ultimoIndex < texto.length) {
        partes.push({
          type: "text",
          value: texto.slice(ultimoIndex)
        });
      }

      return partes;
    },
    getCampoMapeado(variavel) {
      const mapeamento = this.updateKeys.find((item) => item.old_key === variavel);
      return mapeamento ? mapeamento.new_key : "";
    },
    formatCampoLabel(key) {
      if (key === null || key === undefined) return "";
      return String(key).replace(/^\{#/, "").replace(/#\}$/, "").replace(/^#/, "").replace(/#$/, "").replace(/_/g, " ").replace(/\s+/g, " ").trim();
    },
    getValorContato(contato, key) {
      if (!contato || !key) return "";
      const valor = contato[key];
      if (valor === null || valor === undefined) return "";
      return valor;
    },
    aplicarMapeamentosMensagem(mensagem, contato) {
      let texto = mensagem === null || mensagem === undefined ? "" : String(mensagem);

      for (let i = 0; i < this.updateKeys.length; i++) {
        const updateKey = this.updateKeys[i];
        texto = texto.split(updateKey.old_key).join(this.formatCell(this.getValorContato(contato, updateKey.new_key)));
      }

      return texto;
    },
    atualizarPreviewsComMapeamentos() {
      this.previews = (this.previews || []).map((item) => {
        const mensagemOriginal = item && item._mensagemOriginalImport !== undefined ? item._mensagemOriginalImport : item && item.mensagem ? item.mensagem : "";

        return Object.assign({}, item, {
          _mensagemOriginalImport: mensagemOriginal,
          mensagem: this.aplicarMapeamentosMensagem(mensagemOriginal, item ? item.contato : null)
        });
      });
    },
    toggleMenuVariavel(variavelId) {
      if (!this.keys.length) return;
      this.activeVariable = this.activeVariable === variavelId ? null : variavelId;
    },
    fecharMenuVariavel() {
      this.activeVariable = null;
    },
    selecionarCampoParaVariavel(variavel, campo) {
      if (!variavel || !campo) return;

      const mapeamento = this.updateKeys.find((item) => item.old_key === variavel);
      if (mapeamento) {
        mapeamento.new_key = campo;
      } else {
        this.updateKeys.push({ old_key: variavel, new_key: campo });
      }

      this.old_key = variavel;
      this.activeVariable = null;
      this.atualizarPreviewsComMapeamentos();
    },
    voltarParaCampanhas() {
      this.$router.push({ path: "/campanhas" });
    },
    baixarModelo() {
      window.open("/arquivo-modelo-lembrazap-campanha.xlsx", "_blank");
      this.atualizarFeedback("Modelo de importação pronto para download.", "success");
    },
    abrirSeletorArquivoPrincipal() {
      if (this.$refs.arquivoPrincipalInput) {
        this.$refs.arquivoPrincipalInput.click();
      }
    },
    abrirSeletorAnexo() {
      if (this.$refs.anexoInput) {
        this.$refs.anexoInput.click();
      }
    },
    handleArquivoPrincipal(event) {
      const files = (event.target && event.target.files) || [];
      const selectedFile = files[0] || null;
      this.arquivoPrincipal = selectedFile;
      this.form.file = selectedFile;
      this.atualizarFeedback("");
      if (selectedFile) {
        this.enviarArquivoPrincipalPreview(selectedFile);
      }
    },
    async enviarArquivoPrincipalPreview(file) {
      try {
        const payload = new FormData();
        payload.append("file", file);
        const response = await this.$http.post("/v1/campanhasLZV2/preview-campanha-import", payload);
        if (response && response.data) {
          this.updateCampaign(file, response.data);
          this.atualizarFeedback("Arquivo carregado com sucesso!", "success");
        }
      } catch (error) {
        console.error(error);
        this.$vToastify.error("Erro ao processar arquivo");
        this.previews = [];
        this.keys = [];
      }
    },
    handleAnexo(event) {
      const files = (event.target && event.target.files) || [];
      const selectedFile = files[0] || null;
      this.processarAnexoSelecionado(selectedFile);
    },
    soltarArquivoPrincipal(event) {
      this.isPrincipalDragging = false;
      const files = (event.dataTransfer && event.dataTransfer.files) || [];
      const selectedFile = files[0] || null;
      if (!selectedFile) return;
      this.arquivoPrincipal = selectedFile;
      this.form.file = selectedFile;
      this.atualizarFeedback("");
      this.enviarArquivoPrincipalPreview(selectedFile);
    },
    soltarAnexo(event) {
      this.isAnexoDragging = false;
      const files = (event.dataTransfer && event.dataTransfer.files) || [];
      const selectedFile = files[0] || null;
      this.processarAnexoSelecionado(selectedFile);
    },
    async processarAnexoSelecionado(selectedFile) {
      if (!selectedFile) return;
      this.anexo = selectedFile;

      const payload = new FormData();
      payload.append("file", selectedFile);
      payload.append("folder", "arquivosWhats");

      try {
        const response = await this.$http.post("/upload", payload);
        if (response && response.data && response.data.file) {
          this.form.arquivo = response.data.file;
        }
      } catch (error) {
        this.$vToastify.error("Erro ao enviar anexo");
        this.form.arquivo = null;
      }
    },
    importarCampanha() {
      this.save();
    },
    atualizarFeedback(message, type = "warning") {
      this.feedback = { message, type };
    },
    copiarSugestao(sugestao) {
      navigator.clipboard
        .writeText(sugestao)
        .then(() => {
          this.$vToastify.success("Sugestão copiada para a area de transferência!");
        })
        .catch((error) => {
          console.log(error.message);
          this.$vToastify.error("Erro ao copiar sugestão!");
        });
    },
    update(file, response) {
      this.form.arquivo = response.file;
    },
    updateArquivo(file, response) {
      this.form.arquivo = response.file;
    },
    send(file, xhr, formData) {
      formData.append("folder", "arquivosWhats");
    },
    senPreview(file, xhr, formData) {
      if (this.form.editarMensagemManual) formData.append("mensagemEditada", this.form.mensagemEditada);
    },
    updateCampaign(file, response) {
      this.updateKeys = [];
      this.activeVariable = null;
      this.totalDeContatos = response.totalContatos;
      this.form.file = file;
      const previews = Array.isArray(response.data) ? response.data : [];
      this.previews = previews.map((item) =>
        Object.assign({}, item, {
          _mensagemOriginalImport: item && item.mensagem ? item.mensagem : ""
        })
      );
      this.keys = previews[0] && previews[0].contato ? Object.keys(previews[0].contato) : [];
      if (this.previews[0] && this.previews[0]._mensagemOriginalImport) this.form.mensagemEditada = this.previews[0]._mensagemOriginalImport;
      this.editVariaveis = this.extrairVariaveisMensagem(this.form.mensagemEditada).length > 0;
    },
    removeArquivo() {
      this.form.arquivo = null;
    },
    removeFileCampaign() {
      this.form.file = null;
      this.previews = [];
      this.keys = [];
      this.updateKeys = [];
      this.activeVariable = null;
      this.old_key = "";
      this.editVariaveis = false;
    },
    async save() {
      this.isLoading = true;
      const loader = this.$loading.show({
        container: null,
        canCancel: true
      });

      if (this.$store.state.user.lzv2.centrocusto && !this.form.centrocusto) {
        loader.hide();
        this.isLoading = false;
        return this.$vToastify.error("Selecione o centro de custo");
      }

      const dataEnvio = new FormData();
      const dataHoraDisparo = moment(`${this.form.dataDisparo} ${this.form.horaDisparo}`, "YYYY-MM-DD HH:mm").toDate();

      dataEnvio.append("file", this.form.file);
      dataEnvio.append("arquivo", JSON.stringify(this.form.arquivo));
      dataEnvio.append("dataHoraDisparo", dataHoraDisparo);
      dataEnvio.append("nome", this.form.nome);
      dataEnvio.append("updateKeys", JSON.stringify(this.updateKeys));
      const tagsPayload = this.form.etiqueta ? [this.form.etiqueta] : this.form.tags;
      dataEnvio.append("tags", JSON.stringify(tagsPayload));

      if (this.form.editarMensagemManual) dataEnvio.append("mensagemEditada", this.form.mensagemEditada);

      if (this.form.centrocusto) {
        dataEnvio.append("centrocusto", this.form.centrocusto);
      }

      if (this.form.salvarOperador) {
        dataEnvio.append("salvarOperador", this.form.salvarOperador);
      }

      const result = await this.$http.post("/v1/campanhasLZV2/gerar-campanha-import", dataEnvio);

      this.isLoading = false;
      loader.hide();

      if (result.data.success) {
        this.$vToastify.success("Sucesso ao importar campanha");
        this.atualizarFeedback(`Campanha ${this.form.nome || "sem nome"} preparada para importação.`, "success");

        this.isLoadingRedirect = true;

        const redirectLoader = this.$loading.show({
          container: null,
          canCancel: false,
          color: "#000",
          loader: "dots",
          isFullPage: true,
          opacity: 0.5,
          backgroundColor: "#fff",
          zIndex: 999
        });

        setTimeout(() => {
          this.isLoadingRedirect = false;
          redirectLoader.hide();
          this.$router.push({ path: "/campanhas" });
          this.$store.commit("updateSaldoPrePago", result.data.saldoPrePago);
        }, 15000);
      } else {
        this.$vToastify.error(result.data.err);
        this.atualizarFeedback(result.data.err || "Erro ao importar campanha", "warning");
      }
    },
    parafrasearMensagem() {
      this.$vToastify.info("Use a prévia para revisar a mensagem antes do envio.");
    },
    updateMensagemEditada() {
      const mensagem = this.form.mensagemEditada || "";
      const variaveis = this.extrairVariaveisMensagem(mensagem);

      this.updateKeys = this.updateKeys.filter((item) => variaveis.indexOf(item.old_key) !== -1);

      if (this.activeVariable && variaveis.indexOf(this.activeVariable) === -1) {
        this.activeVariable = null;
      }

      this.previews = this.previews.map((p) =>
        Object.assign({}, p, {
          _mensagemOriginalImport: mensagem
        })
      );
      this.editVariaveis = variaveis.length > 0;
      this.atualizarPreviewsComMapeamentos();
    },
    removerSubstituicao(updateKey, idx) {
      this.updateKeys.splice(idx, 1);
      if (this.activeVariable === updateKey.old_key) {
        this.activeVariable = null;
      }
      this.atualizarPreviewsComMapeamentos();
    },
    substituir(key) {
      if (!this.old_key || !this.old_key.trim()) {
        return this.$vToastify.error("Digite a variável a ser substituída");
      }

      if (!key) {
        return this.$vToastify.error("Selecione um campo para mapeamento");
      }

      this.selecionarCampoParaVariavel(this.old_key, key);
      this.$vToastify.success(`Variável "${this.old_key}" mapeada para "${key}"`);
      this.old_key = "";
    },

    aplicarSubstituicao(event) {
      const key = event.target.value;
      if (key) {
        this.substituir(key);
        event.target.value = "";
      }
    },
    openContextMenu(e) {
      this.old_key = window.getSelection().toString();

      if (this.old_key.trim() === "") {
        this.old_key = null;
        return this.$vToastify.error("A seleção da váriavel não pode ser um espaço vazio!");
      }

      this.$refs.menu.open(e);
    },
    formatCell(val) {
      if (val === null || val === undefined) return "";
      if (typeof val === "object") {
        try {
          return JSON.stringify(val);
        } catch (e) {
          return String(val);
        }
      }
      return String(val);
    },

    formatPreviewContact(contato) {
      if (!contato) return "—";
      const values = Object.values(contato)
        .filter((v) => v !== null && v !== undefined)
        .slice(0, 2)
        .join(" - ");
      return values || "—";
    },

    getHtmlFrom(str) {
      return formatarMensagem(str);
    }
  },
  async beforeMount() {
    this.form.nome = `${moment().format("x")}`;
    this.form.dataDisparo = moment().format("YYYY-MM-DD");
    this.form.horaDisparo = moment().add(40, "m").format("HH:mm");
    this.form.ignoraTrava = true;

    const centroscustoReq = await this.$http.post(`/v1/centrocusto/list`, { all: true });
    this.centroscusto = centroscustoReq.data.data;

    if (this.$store.state.user.centrocusto && !this.$store.state.user.admin) {
      this.form.centrocusto = this.$store.state.user.centrocusto;
    }

    const tagReq = await this.$http.post("/v1/tag/list", { all: true });
    this.tags = tagReq.data.data;

  }
};
</script>

<style scoped>
#centrocusto,
#etiqueta {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background-image: none !important;
}

#centrocusto::-ms-expand,
#etiqueta::-ms-expand {
  display: none;
}

.select-icon {
  position: absolute;
  right: 0.75rem;
  top: 50%;
  pointer-events: none;
  color: #9ca3af;
  transform: translateY(-50%);
  transition: transform 0.2s ease, color 0.2s ease;
}

.group:focus-within .select-icon {
  transform: translateY(-50%) rotate(180deg);
}
</style>
